import $ from 'jquery';

export default class Tabs {
    constructor($elem) {
        this.$elem = $elem;

        this.click__tab = this.click__tab.bind(this);

        this.init();
    }

    click__tab(ev) {
        ev.preventDefault();

        // Grab some landmarks
        var this_link  = $(ev.currentTarget),
            my_li      = this_link.parents('.tabs__nav__item'),
            my_nav     = this.$elem.find('.tabs__nav'),
            my_lis     = this.$elem.find('.tabs__nav__item'),
            my_tabs    = this.$elem.find('.tabs__tab'),
            links      = my_nav.find('a'),

            // Find the tab number
            index       = links.index(this_link),

            // Get the currently active tab & nav item
            active_li  = this.$elem.find('.tabs__nav__item.is-active'),
            active_tab = this.$elem.find('.tabs__tab.is-active');

            window.location.hash = this_link.attr('href');

        // Don't do anything if we're already active
        if (! my_li.hasClass('is-active')) {
            // Toggle the active state
            active_li.removeClass('is-active');
            active_tab.removeClass('is-active');

            my_lis.eq(index).addClass('is-active');
            my_tabs.eq(index).addClass('is-active');

            this.$elem.trigger('tab__switch');

            this.$elem.parents('.page__content__inner').find('.posts-date-filter a').each((k, v) => {
                $(v).attr('href', $(v).data('orig-href') + window.location.hash);
            });
        };
    }

    init() {
        this.$elem.on('click', '.tabs__nav__link', this.click__tab);
        // Default
        if (window.location.hash) {
            let my_hash = window.location.hash.substring(1),
                lis  = this.$elem.find('.tabs__nav__item'),
                tabs = this.$elem.find('.tabs__tab'),
                selected_li = lis.parent().find(`[href="#${my_hash}"]`).parent(),
                li_index = lis.index(selected_li),
                selected_tab = tabs.eq(li_index);

            lis.removeClass('is-active');
            tabs.removeClass('is-active');

            selected_li.addClass('is-active');
            selected_tab.addClass('is-active');

            this.$elem.parents('.page__content__inner').find('.posts-date-filter a').each((k, v) => {
                $(v).attr('href', $(v).data('orig-href') + '#' + my_hash);
            });
        }
    }
}
